import { Link } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";

export const Hero = () => {
  return (
    <section
      data-testid="hero"
      className="relative flex w-full flex-col justify-between overflow-hidden pt-24 pb-10"
    >
      {/* Background image */}
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1610452325665-d5e09698d9ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
          filter: "grayscale(1) contrast(1.1)",
        }}
      />
      <div className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-[#050505]/30 via-[#050505]/60 to-[#050505]" />

      {/* HUGE logo — anchored to the actual top-right corner of the hero (offset to clear navbar) */}
      <div
        data-testid="hero-logo-mark"
        className="pointer-events-none absolute right-0 top-28 z-10 hidden md:block"
      >
        <div className="rise opacity-95">
          <BrandMark size="huge" />
        </div>
      </div>

      {/* Top marker */}
      <div className="mx-auto w-full max-w-[1400px] px-6 md:px-10">
        <div className="flex items-center justify-between rise">
          <span className="font-mono-stamp text-[10px] text-[#a0a0a0]">
            DROP 001 / NOW LIVE
          </span>
          <span className="font-mono-stamp text-[10px] text-[#a0a0a0]">
            EST. 2025 / SYDNEY
          </span>
        </div>
      </div>

      {/* Main content */}
      <div className="mx-auto w-full max-w-[1400px] flex-1 px-6 py-10 md:px-10 md:py-16">
        <div className="relative grid grid-cols-12 gap-6">
          <div className="relative z-20 col-span-12 md:col-span-9">
            <p className="rise rise-d1 font-mono-stamp text-xs text-[#a0a0a0]">
              ▸ OWN YOUR BAS1C
            </p>
            <h1
              data-testid="hero-headline"
              className="font-logo rise rise-d2 mt-6 text-[16vw] leading-[0.92] md:text-[13vw] lg:text-[10rem]"
            >
              BAS1C<span className="text-[#666]">.</span>
              <br />
              <span className="text-outline" style={{ fontFamily: "'Cabinet Grotesk', sans-serif", letterSpacing: "-0.02em" }}>The Brand</span>
            </h1>
            <p className="rise rise-d3 mt-8 max-w-xl font-mono-stamp text-xs leading-relaxed text-[#a0a0a0] md:text-sm">
              ONE DROP. ALL VIBE. NO LABELS. CLASSIC CUTS AND FITS MADE FOR
              EVERY BODY. DESIGNED IN LIMITED RUNS — ONCE THEY'RE GONE, THEY'RE
              GONE.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom CTAs */}
      <div className="mx-auto w-full max-w-[1400px] px-6 md:px-10">
        <div className="rise rise-d4 flex flex-col items-stretch gap-4 border-t border-[#333] pt-8 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col gap-3 md:flex-row md:gap-6">
            <a
              href="#drop"
              data-testid="hero-shop-cta"
              className="btn-brutal btn-brutal-solid"
            >
              SHOP THE DROP →
            </a>
            <Link
              to="/find-your-fit"
              data-testid="hero-fit-cta"
              className="btn-brutal"
            >
              FIND YOUR FIT →
            </Link>
          </div>
          <a
            href="#join"
            data-testid="hero-join-cta"
            className="font-mono-stamp text-xs text-[#a0a0a0] underline underline-offset-4 hover:text-white"
          >
            JOIN THE LIST ▸ GET EARLY ACCESS
          </a>
        </div>
      </div>
    </section>
  );
};
